/**
 * @export
 * @param {*} strings
 * @param {*} key
 * @param {*} [replace={}]
 */
export function translate(strings, key, replace = {}) {
  let translation

  try {
    translation = key.split('.').reduce((t, i) => t[i] || null, strings)

    if (translation && replace) {
      for (let [key, value] of Object.entries(replace)) {
        translation = translation.replace('{' + key + '}', value)
      }
    }

    if (!translation) {
      translation = key
    }
  } catch (e) {
    translation = key
  }

  return translation
}
